export default __webpack_public_path__ + "static/media/banner_form.67656dcc.png";